export const XMLNS = 'http://www.w3.org/2000/svg';

export const MAP = {
  ZOOM: 15,
};

export const GRID = {
  MAX_ZOOM: 14,
};

export const HEX = {
  WIDTH: 96, //px
  STROKE_WIDTH: 5,
  BIG_HEX_ZOOM: 17.5,
};

//------------------------------------------------------------------------------

export const ZINDEX = {
  CANVAS_GRID: 1000,
  CANVAS_HEX: 1001,
  CARD: 1002,
  MODAL: 2000,
  OVERLAY: 9999,
};
